var React = require('react');

function PlusInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"fill":"#67696E"},React.createElement("g",null,React.createElement("g",null,React.createElement("g",null,React.createElement("path",{"d":"M373.2 77v6.799l6.8.001v2.4h-6.8V93h-2.4v-6.8H364v-2.4l6.8-.001V77h2.4z","transform":"translate(-712 -587) translate(332 118) translate(0 198) translate(16 194)"})))))));
}

PlusInline.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","className":"svg"};

module.exports = PlusInline;

PlusInline.default = PlusInline;
